<template>
<div v-if="EnterpriseId&&EnterpriseId.length">
    <span v-if="typeNow === 'index'">
        <img  :id="'net-'+typeNow"  v-if="!isShow.index" src="@/assets/images/banner-index.jpg" :style="{'width':size}"/>
        <img  :id="'net-'+typeNow"  v-else :src="getStoreImg('index')" @error="loadDefault('index')" :style="{'width':size}"/>
    </span>
    <span v-if="typeNow === 'personal'">
        <img  :id="'net-'+typeNow"  v-if="!isShow.personal" src="@/assets/images/banner-personal.jpg" :style="{'width':size}"/>
        <img  :id="'net-'+typeNow"  v-else :src="getStoreImg('personal')" @error="loadDefault('personal')" :style="{'width':size}"/>
    </span>
    <span v-if="typeNow === 'swiper1'">
        <img  :id="'net-'+typeNow"  v-if="!isShow.swiper1" src="@/assets/images/banner-swiper1.jpg" :style="{'width':size}"/>
        <img  :id="'net-'+typeNow"  v-else :src="getStoreImg('swiper1')" @error="loadDefault('swiper1')" :style="{'width':size}"/>
    </span>
    <span v-if="typeNow === 'swiper2'">
        <img  :id="'net-'+typeNow"  v-if="!isShow.swiper2" src="@/assets/images/banner-swiper2.jpg" :style="{'width':size}"/>
        <img  :id="'net-'+typeNow"  v-else :src="getStoreImg('swiper2')" @error="loadDefault('swiper2')" :style="{'width':size}"/>
    </span>
    <span v-if="typeNow === 'swiper3'">
        <img  :id="'net-'+typeNow"  v-if="!isShow.swiper3" src="@/assets/images/banner-swiper3.jpg" :style="{'width':size}"/>
        <img  :id="'net-'+typeNow"  v-else :src="getStoreImg('swiper3')" @error="loadDefault('swiper3')" :style="{'width':size}"/>
    </span>
</div>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      bannerIndexUrl:'',
      bannerPersonalUrl:'',
      isShow:{
        index:false,
        personal:false,
        swiper1:true,
        swiper2:true,
        swiper3:true,
      },

    };
  },
  props: {
    typeNow: {
      type: String,
      default: () => {
        return 'index';
      },
    },
    size: {
      type: String,
      default: () => {
        return '100%';
      },
    },
  },
  watch:{
    EnterpriseId:{
      handler(val,oldval){
        if(val){
          this.isShow[this.typeNow] = true;
        }
      },
      deep:true
    }
  },
  methods:{
      loadDefault(tag){
        this.isShow[tag] = false;
      },
      getStoreImg(name){
        let userInfo = this.$store.getters.getUserInfo;
        let uri = location.origin + "/infoplus/file/enterprise/" + userInfo.enterprise.id + "/icon/banner-" + name;
        return uri;
      }, 
  },
  computed:{
    EnterpriseId(){
      if( this.$store.getters.getUserInfo&&this.$store.getters.getUserInfo.enterprise){
          return  this.$store.getters.getUserInfo.enterprise.id;
      }else{
          return '';
      }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/todoCenter/bannerImg.vue